<script setup lang="ts">
/* eslint-disable max-len */
</script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.819 2.181A2.668 2.668 0 0 0 11.2 0H2.667A2.668 2.668 0 0 0 0 2.667V11.2c0 1.307.944 2.39 2.181 2.619A2.668 2.668 0 0 0 4.8 16h8.533A2.668 2.668 0 0 0 16 13.333V4.8c0-1.307-.944-2.39-2.181-2.619zm-2.352 7.35-3.734 2.133a.538.538 0 0 1-.266.07.524.524 0 0 1-.267-.07.535.535 0 0 1-.267-.464V6.933c0-.192.102-.368.267-.464a.557.557 0 0 1 .533 0l3.734 2.134a.535.535 0 0 1 0 .928zM4.8 2.133A2.668 2.668 0 0 0 2.133 4.8v7.904A1.606 1.606 0 0 1 1.067 11.2V2.666c0-.88.72-1.6 1.6-1.6H11.2c.693 0 1.28.448 1.504 1.067H4.8z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
